// Стратегии («карты дел») для вкладки «Стратегия» в карточке гражданского дела.
// days — через сколько дней от сегодняшнего поставить задачу при нажатии «Добавить шаги в задачи».
// docs — id документов в «Правовой базе» (таблица legal_docs).

export const PLAYBOOKS = {
  dtp_animals: {
    title: 'ДТП с животными — ущерб автомобилю',
    categories: ['dtp'],
    when: [
      'ДТП оформлено ГИБДД (определение/постановление, КУСП), ущерб от 50 000 ₽.',
      'Есть шанс найти владельца животных (стадо у трассы, бирки, клеймо) или вопрос к владельцу дороги (нет знака 1.26).',
      'Есть КАСКО — сначала страховая. ГИБДД не вызывали — шансы низкие, сказать прямо.',
    ],
    questions: [
      'Дата, время, километр, направление, освещение, скорость',
      'Кто оформлял; что в определении — есть ли вывод о нарушении ПДД (п. 10.1)',
      'SOS/112, пассажиры (ФИО, телефоны, дети), фото, видео, регистратор',
      'Куда ушли животные, стадо, пастух, ферма; бирки, клеймо, масть',
      'Машина: в кредите/залоге, КАСКО, дефектовка',
    ],
    urgent: [
      'Жалоба на вывод о нарушении ПДД — 10 дней с получения копии определения (ст. 30.3 КоАП)',
      'Следы на машине — собрать сразу по акту, машину не мыть',
      'Записи камер хранятся 7–30 дней',
    ],
    steps: [
      { id: 'contract', text: 'Договор и оплата досудебного этапа', days: 0 },
      { id: 'complaint', text: 'Жалоба в районный суд на определение ГИБДД (вывод о нарушении ПДД) — срок 10 дней', days: 3, docs: [3] },
      { id: 'police', text: 'Заявления в полицию: об оформлении ДТП и об установлении владельца животных — получить номера КУСП', days: 2, docs: [4, 5] },
      { id: 'traces', text: 'Акт сбора следов с машины при свидетелях; объяснения пассажиров', days: 1, docs: [11, 12] },
      { id: 'requests', text: 'Запросы: администрация поселения, ветстанция, ГИБДД о прежних ДТП на участке', days: 5, docs: [8, 9, 6] },
      { id: 'road', text: 'Видеосъёмка участка дороги (знаки, ограждения) + опрос местных; потом запрос владельцу дороги', days: 7, docs: [10, 7] },
      { id: 'defect', text: 'Дефектовка у дилера → независимая оценка (ремонт без износа, УТС), владельца известить телеграммой', days: 10, docs: [13] },
      { id: 'check_police', text: 'Узнать ход проверки по КУСП: установлен ли владелец животных', days: 21 },
      { id: 'claim', text: 'Претензия владельцу животных', days: 30 },
      { id: 'lawsuit', text: 'Иск в районный суд (ст. 1064, 137, 210 ГК, п. 25.6 ПДД): ремонт, УТС, оценка, эвакуатор, госпошлина, юрист', days: 45 },
    ],
    risks: [
      'Вывод о «небезопасной скорости» → грубая неосторожность (ст. 1083 ГК), выплату снизят. Обжаловать сразу.',
      'Владелец не найден или неплатёжеспособен. Запасной ответчик — владелец дороги.',
      'Машина в залоге — уведомление банку, если банк требует (спросить письменно).',
      'Не работать без договора — из практики клиент останавливается после бесплатных документов.',
    ],
    price: ['Анализ — 5 000 ₽', 'Досудебный этап — 10 000 ₽', 'Суд 1 инстанции — 35 000–40 000 ₽ или фикс + 10–15% от взысканного', 'Оценка, госпошлины, почта — клиент'],
    extra: [{ label: 'Статья для клиента', href: 'https://ucfemida.ru/poleznoe/dtp-s-zhivotnymi/' }, { label: 'Уведомление банку о залоге', doc: 15 }, { label: 'Памятка клиенту', doc: 14 }],
  },

  land_large_family: {
    title: 'Земельный участок многодетным (Башкортостан)',
    categories: ['land'],
    when: [
      'Трое и более несовершеннолетних детей + нуждаемость в жилье (ст. 10 ч. 2 п. 3 Закона РБ № 59-з).',
      'Свой участок от 0,08 га многодетным не мешает. Вместо участка можно 250 000 ₽.',
      'Главная ловушка — бюджетные деньги на жильё (ст. 10.1 ч. 3 п. 5), например выплата 300 000 ₽ за первенца. Шансы тогда ~50/50.',
    ],
    questions: [
      'Дети: возраст, живут ли с заявителем; брак/развод',
      'Жильё: площадь, собственник, сколько человек; земля в собственности',
      'Какие меры поддержки получали, когда (до/после третьего ребёнка) и на что потратили',
      'Признавали ли нуждающимися, стоят ли на учёте; отказ устный или письменный',
    ],
    urgent: ['Административный иск — 3 месяца со дня письменного отказа (гл. 22 КАС)'],
    steps: [
      { id: 'contract', text: 'Договор и оплата досудебного этапа', days: 0 },
      { id: 'docs', text: 'Собрать: свидетельства детей, брак/развод, состав семьи, ЕГРН на жильё и участки, документы о выплатах, справка Госуслуг о мерах соцподдержки', days: 5 },
      { id: 'apply', text: 'Заявление о постановке на учёт (земельная комиссия, 30 дней) — получить входящий номер', days: 7 },
      { id: 'answer', text: 'Контроль решения комиссии: нужен ПИСЬМЕННЫЙ отказ с пунктом закона', days: 40 },
      { id: 'prosecutor', text: 'Жалоба в прокуратуру на отказ (со ссылкой на п. 19 Обзора ВС 19.11.2025)', days: 45 },
      { id: 'kas', text: 'Административный иск (гл. 22 КАС) — подаёт клиент сам, мы готовим документы (ст. 55 КАС)', days: 60 },
    ],
    risks: [
      'По букве закона РБ бюджетная выплата на жильё — основание отказа. Спор через позицию ВС (п. 19): учитывается только то, что было после рождения третьего ребёнка.',
      'По КАС без высшего юр. образования не представляем — клиент подаёт и участвует сам.',
      'Долго: апелляция (ВС РБ), кассация (6 КСОЮ) — до года.',
    ],
    price: ['Анализ — 5 000 ₽', 'Досудебный этап — 8 000 ₽', 'Административный иск — 6 000 ₽; апелляционная/кассационная жалоба — 8 000 ₽', 'Госпошлины — клиент'],
    extra: [{ label: 'Закон РБ № 59-з', doc: 1 }, { label: 'Обзор ВС 19.11.2025', doc: 2 }, { label: 'Статья для клиента', href: 'https://ucfemida.ru/poleznoe/otkaz-v-uchastke-mnogodetnym/' }],
  },

  realty_no_docs: {
    title: 'Купил недвижимость без документов (дача, участок по расписке)',
    categories: ['realty', 'land', 'documents', 'inheritance'],
    when: [
      'Деньги уплачены, покупатель пользуется, но права продавца не оформлены (наследство, участок 90-х, нет в ЕГРН).',
      'Лучше всего — пока продавец жив и готов помогать: тогда без суда за 2–3 месяца.',
    ],
    questions: [
      'Документы: договор, расписка, госакт/свидетельство 90-х, книжка СНТ',
      'Кто продавец и кем приходится владельцу; жив ли, есть ли связь',
      'Оформлено ли наследство, другие наследники, у какого нотариуса дело',
      'Сколько лет пользуется, платит ли взносы; есть ли участок в ЕГРН и границы',
    ],
    urgent: ['Подписать предварительный договор с продавцом, пока он на связи'],
    steps: [
      { id: 'check', text: 'Проверка: ЕГРН / кадастровая карта, реестр наследственных дел (notariat.ru)', days: 1 },
      { id: 'predv', text: 'Предварительный договор с продавцом + нотариальная доверенность от продавца', days: 5, docs: [16] },
      { id: 'cadastre', text: 'Кадастровый инженер: ранее учтённый участок + межевой план, согласование границ (Справочники → Контакты)', days: 7 },
      { id: 'zags', text: 'Документы о родстве для наследства (ЗАГС: повторные свидетельства)', days: 12 },
      { id: 'notary', text: 'Нотариус: свидетельство о праве на наследство продавцу', days: 20 },
      { id: 'register', text: 'МФЦ одной подачей: границы + регистрация права продавца (п. 9.1 ст. 3 137-ФЗ)', days: 45 },
      { id: 'sale', text: 'Основной договор купли-продажи → регистрация перехода права на покупателя', days: 55 },
    ],
    risks: [
      'Продавец уклоняется — иск о понуждении (ст. 429, 445 ГК) или о регистрации перехода права (ст. 551 ГК).',
      'Продавец умер — требования к его наследникам.',
      'Никого нет — приобретательная давность (ст. 234 ГК): на практике около 18 лет владения.',
    ],
    price: ['Анализ — 5 000 ₽', 'Сопровождение — по объёму, назвать до начала', 'Кадастр, нотариус, госпошлины — по договору на продавце'],
    extra: [{ label: 'Статья для клиента', href: 'https://ucfemida.ru/poleznoe/kupili-dachu-po-raspiske/' }],
  },

  victim_assault: {
    title: 'Побои и повреждение имущества — потерпевший',
    categories: [],
    when: [
      'Есть обращение в полицию (талон, КУСП) или клиент готов его подать; побои сняты либо следы ещё видны.',
      'Берём отдельными оплаченными шагами: анализ → заявление/жалоба → иск. «Под ключ до результата» не берём. До оплаты работу не делаем.',
      'По имуществу — только если вещи клиента (чеки, выписки, кредит, свидетели). Куплено виновным или вместе — эту часть не берём.',
      'Ограничиться консультацией, если виновный без дохода и имущества, а клиент сомневается, доводить ли до конца.',
    ],
    questions: [
      'Когда и где произошло, кто видел или слышал; вызывали ли полицию, есть ли талон-уведомление и номер КУСП',
      'Медицинские документы: травмпункт или освидетельствование по направлению полиции; что в них написано',
      'Привлекался ли он раньше за побои (административно) или судим за насилие — от этого зависит, КоАП или УК',
      'Чьё жильё, кто собственник; на кого и на чьи деньги куплены повреждённые вещи; есть ли чеки, выписки, кредит',
      'Его ФИО, дата рождения, адрес, работа и доход, имущество',
      'Чего клиент хочет: наказания, денег, чтобы он съехал; не собирается ли мириться',
    ],
    urgent: [
      'Освидетельствование — пока видны следы: попросить в полиции направление на судебно-медицинское освидетельствование',
      'В заявлении указать и побои, и повреждение имущества с суммой и словами «ущерб для меня значительный»',
      'Фото травм и повреждений; сломанные вещи не выбрасывать до конца разбирательства',
      'Проверка сообщения о преступлении: 3 суток, продление до 10 и до 30 (ст. 144 УПК)',
    ],
    steps: [
      { id: 'consult', text: 'Бесплатная консультация в офисе: выслушать, сказать, есть ли смысл и что будет стоить; дальше — платный анализ или договор', days: 0 },
      { id: 'police', text: 'Заявление в полицию (побои + имущество + просьба о СМО), получить талон-уведомление', days: 1 },
      { id: 'check', text: 'Узнать результат проверки: дело по ст. 6.1.1 КоАП / возбуждение по ст. 167, 115, 116.1 УК / отказ', days: 14 },
      { id: 'appeal', text: 'Если отказ в возбуждении — жалоба прокурору или в суд (ст. 125 УПК)', days: 21 },
      { id: 'value', text: 'Оценка ущерба: чеки и цены аналогов или отчёт оценщика; смета на ремонт дверей', days: 21 },
      { id: 'civil_in_criminal', text: 'Если возбуждено уголовное дело — гражданский иск в нём (ст. 44 УПК), без пошлины', days: 30 },
      { id: 'lawsuit', text: 'Если только административное дело — после постановления суда иск в районный суд по месту жительства клиента: ущерб, лечение, моральный вред (ст. 1064, 151 ГК; ч. 4 ст. 61, ч. 5 ст. 29 ГПК)', days: 35 },
    ],
    risks: [
      'Примирение: по ч. 1 ст. 115 и ч. 1 ст. 116.1 УК (частное обвинение) дело прекращается — оплату брать вперёд за каждый шаг.',
      'Имущество не «чужое» для виновного (купил сам или вместе) — состава по ст. 167 УК и ст. 7.17 КоАП в этой части нет.',
      'Ущерб признают незначительным (меньше 5 000 ₽ или с учётом дохода) — только ст. 7.17 КоАП, штраф 300–500 ₽.',
      'Неплатёжеспособность: решение будет, взыскать не с чего — предупредить клиента до иска.',
      'В административном деле моральный вред не взыскивается (ч. 3 ст. 4.7 КоАП) — только отдельным иском.',
      'Мы не адвокаты: в уголовном деле представителем допускают по ходатайству потерпевшего (ч. 1 ст. 45 УПК), в административном — по доверенности (ст. 25.5 КоАП).',
    ],
    price: ['Консультация — бесплатно', 'Анализ с погружением в документы — 5 000 ₽', 'Заявление в полицию или жалоба на отказ — 2 000 ₽', 'Иск о возмещении вреда — 6 000 ₽', 'Суд 1 инстанции — 10 000–15 000 ₽', 'Оценка ущерба и госпошлина — отдельно, за счёт клиента'],
    extra: [{ label: 'Страница для клиента', href: 'https://ucfemida.ru/poboi-i-povrezhdenie-imushchestva/' }],
  },
};

// какую стратегию предложить по умолчанию для категории дела
export const defaultPlaybook = category =>
  Object.keys(PLAYBOOKS).find(k => PLAYBOOKS[k].categories[0] === category)
  || Object.keys(PLAYBOOKS).find(k => PLAYBOOKS[k].categories.includes(category)) || '';
